// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "" + chunkId + "." + {"22":"042c1274c475d9919ad8","71":"09a9ef024e37728def41","452":"6eb2015aec08a7296e0b","885":"1913f6f07514803944e2","961":"4ed1b28293b1c76b58c0"}[chunkId] + ".css";
};